import React, { Component, } from "react"
import styled from 'styled-components';

import ProfileImage from "../components/profileImage/Image";
import {ActionButtonTitle, IconLessButtonTitle, Body, Title} from "../components/Fonts";
import Footer from "../components/footer/Footer";
import NavigationHeader from "../components/navigationHeader/NavigationHeader";

import texture from './texture.png';

import { withRouter } from "react-router-dom"
import {ActionButton, ButtonIcon} from "../components/button/ActionButton";
import appleIcon from "../images/icons/apple.png";
import {SectionGroup, SectionItem} from "../components/conatiner/Container";


const invitesEndPoint = process.env.REACT_APP_INVITES_ENDPOINT_URL ? process.env.REACT_APP_INVITES_ENDPOINT_URL: "https://api-dot-zebra-staging-app.uc.r.appspot.com/v1/invites/"
//const invitesEndPoint = "https://api-dot-zebra-staging-app.uc.r.appspot.com/v1/invites/"

const TexturedBackground = styled.div`
  position: relative;
  width: calc(100% - 48px);
  max-width: 720px;
  min-width: 320px;
  margin: auto;
  padding-top: 0;
  padding-left: 24px;
  padding-right: 24px;

  @media only screen and (max-width: 896px) {
    width: calc(100% - 160px);
    padding-left: 80px;
    padding-right: 80px;
  }

  @media only screen and (max-width: 512px) {
    width: calc(100% - 48px);
    padding-left: 24px;
    padding-right: 24px;
  }
`;

const Wrapper = styled.section`
  margin: auto;
  padding: 80px 40px;
  // position: relative;
  width: calc(100% - 80px);
  max-width: 1020px;
  // top: 44%;
  //-webkit-transform: translateY(-50%);
  //-ms-transform: translateY(-50%);
  //transform: translateY(-50%);

  @media only screen and (max-width: 896px) {
    padding-left: 0;
    padding-right: 0;
    padding-top: 64px;
    width: 100%;
  }
`;

const DownloadButton = styled(ActionButton)`
  margin-top: 80px;

  @media only screen and (max-width: 896px) {
    margin-top: 40px;
  }
`;

class InvitePage extends Component {

  // @ts-ignore
  constructor(props) {
    super(props)
    const inviteId = props.match.params.id

    this.state = {
      error: false,
      result: {},
    };
  }

  componentDidMount() {
  // @ts-ignore
    const url = invitesEndPoint + this.props.match.params.id    
    fetch(url)
      .then(res => res.json())
      .then(
        (result) => {         
          
          this.setState({
            result: result,
            error: false,
          });
        },
        (error) => {
          console.log("error: " + error)
          this.setState({
            error: true,
          });
        }
      )
  }


  componentWillMount() {

  
  }
  
      // @ts-ignore
   componentDidUpdate(prevProps, prevState, snapshot) {
     // @ts-ignore     
     const result  = this.state.result
     if (result && result.name != "") {
       // @ts-ignore
      //const deepLink = `zebrachat://addFriend?inviteId=${this.props.match.params.id}&name=${result.name}&profileImage=${encodeURIComponent(result.profileImage)}`      
      // @ts-ignore 
      //window.location = deepLink
     }
     
    }

  
  onDownload = () => {
    // @ts-ignore
    navigator.clipboard.writeText("zebraInviteId=" + this.props.match.params.id)
    

    // @ts-ignore
    window.location = this.state.result.downloadLink
    //window.location = "joinzebra://"
  }


  onAppStore = () => {

  }
  
  render() {
    // @ts-ignore
     const { error,  result } = this.state;

     if (result && result.downloadLink && result.downloadLink != "") {

      if (result.remaining <= 0) {
        return ( 
            <TexturedBackground>
              <NavigationHeader />
              <Wrapper>
                <ProfileImage image={result.profileImage}/>
                <Title>
                  Invite from {result.name}
                </Title>
                <Body>
                  {result.name} sent you an invite and wants to share on Zebra!
                </Body>
                <DownloadButton height={64} onClick={this.onAppStore}>
                  <ButtonIcon icon={appleIcon} tint={"#FAF8F7"}/>
                  <ActionButtonTitle>Download</ActionButtonTitle>
                </DownloadButton>
              </Wrapper>
              <Footer />
            </TexturedBackground>
        ) 
      }

      return (
            <TexturedBackground>
              <NavigationHeader />
              <Wrapper>
                <ProfileImage image={result.profileImage}/>
                <Title>
                  Invite from {result.name}
                </Title>
                <Body>
                  {result.name} sent you an invite and wants to share on Zebra!
                </Body>
                <DownloadButton height={64} onClick={this.onDownload}>
                  {/* <ButtonIcon icon={appleIcon} tint={"#FAF8F7"}/> */}
                  <IconLessButtonTitle>Accept Invite</IconLessButtonTitle>
                </DownloadButton>
              </Wrapper>
              <Footer />
            </TexturedBackground>
          );
     } else {
       return null
     }
    
   
  }

 
  
}

// @ts-ignore
export default withRouter(InvitePage)
